
import Vue from "vue"
import "leaflet/dist/leaflet.css"
import L from "leaflet"

// Fix Leaflet marker icons issue
delete (L.Icon.Default.prototype as any)._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

interface AddressPosition {
  latitude: number
  longitude: number
}

export default Vue.extend({
  name: 'AddressPositionMap',
  props: {
    position: {
      type: Object as () => AddressPosition | null,
      default: null
    },
    height: {
      type: String,
      default: '300px'
    },
    zoom: {
      type: Number,
      default: 15
    }
  },
  data: () => ({
    map: null as L.Map | null,
    marker: null as L.Marker | null,
    mapInitialized: false,
    mapId: `addressMap_${Math.random().toString(36).substr(2, 9)}`
  }),
  watch: {
    position: {
      handler(newPosition: AddressPosition | null) {
        if (newPosition && !this.mapInitialized) {
          this.$nextTick(() => {
            this.initializeMap()
          })
        } else if (newPosition && this.mapInitialized && this.map) {
          this.updateMapMarker(newPosition)
        }
      },
      immediate: true
    }
  },
  beforeDestroy() {
    this.destroyMap()
  },
  methods: {
    initializeMap() {
      if (!this.position || this.mapInitialized) return

      const mapContainer = document.getElementById(this.mapId)
      if (!mapContainer) return

      // Initialize the map
      this.map = L.map(this.mapId, { attributionControl: false }).setView([
        this.position.latitude,
        this.position.longitude
      ], this.zoom)

      // Add OpenStreetMap tiles
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(this.map)

      // Add marker for the address
      this.marker = L.marker([
        this.position.latitude,
        this.position.longitude
      ]).addTo(this.map)

      this.mapInitialized = true
    },
    updateMapMarker(position: AddressPosition) {
      if (!this.map) return

      // Remove existing marker
      if (this.marker) {
        this.map.removeLayer(this.marker)
      }

      // Add new marker
      this.marker = L.marker([position.latitude, position.longitude]).addTo(this.map)
      
      // Update map view
      this.map.setView([position.latitude, position.longitude], this.zoom)
    },
    destroyMap() {
      if (this.map) {
        this.map.remove()
        this.map = null
        this.marker = null
      }
      this.mapInitialized = false
    }
  }
})
